import React from "react";
import Box from "@mui/material/Box";
import { FormControl } from "@mui/material";

export const MARGINS = 0;

export default function DetailPage(props: {
    children: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined;
}): JSX.Element {
    return (
        <Box paddingLeft={MARGINS} paddingRight={MARGINS} marginTop={0}>
            <FormControl fullWidth>{props.children}</FormControl>
        </Box>
    );
}
